import { Input, Modal } from 'antd';
import { useEffect, useState } from 'react';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (remark?: string) => void;
}

const ConfirmDialog = ({ isOpen, onClose, onConfirm }: ConfirmDialogProps) => {
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (!isOpen) {
      setValue('');
    }
  }, [isOpen]);

  const handleOk = () => {
    onConfirm(value);
  };

  return (
    <Modal
      open={isOpen}
      title="确认通过理由"
      onCancel={onClose}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
      destroyOnClose
    >
      <Input
        placeholder="（选填）通过原因"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </Modal>
  );
};

export default ConfirmDialog;
